import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import menu from "./header/MenuData";
import Head from "./head/Head";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import AppRoot from "./global/AppRoot";
import AppWrap from "./global/AppWrap";

import FileManagerProvider from "@/pages/app/file-manager/components/Context";
import { PageLoader } from '@/components/ui/PageLoader';

const Layout = ({ title }) => {
  return (
    <FileManagerProvider>
      <Head title={!title && 'Loading'} />
      <AppRoot>
          <AppWrap className="trading-workspace">
            <a className='workspace-skip-link' href='#workspace-main'>Skip to dashboard</a>
            <Header menuData={menu} fixed />
            <div id='workspace-main' tabIndex={-1}>
              <Suspense fallback={<PageLoader />}><Outlet /></Suspense>
            </div>
            <Footer />
          </AppWrap>
      </AppRoot>
    </FileManagerProvider>
  );
};
export default Layout;
